import { BehaviorSubject } from 'rxjs';

const APP_ID = process.env.REACT_APP_ID;
/*const localBack = url.localBack;*/
const localBack = process.env.REACT_APP_BACK;

const currentUser = {
    username: '', 
    emailAddress: '',
    netId: '',
    idinv: 0,
    idunidad: 0,
    unidad: '',
    nombres: '',
    apellidos: '',
    tipoidentificacion: '',
    numeroidentificacion: '',
    codestudiante: '',
    idpersona: 0,
    roles: [],
    foto: '',
    token: ''
};

const currentUserSubject = new BehaviorSubject(currentUser);

export const authService = {
  login,
  logout,
  currentUser: currentUserSubject.asObservable(),
  get currentUserValue() { return currentUserSubject.value },
};

function login(username) {
    fetch(localBack + "/api/Account", {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ idapp: APP_ID, netid: username })
    })
        .then(response => response.json())
        .then((result) => {
            // console.log(result);
            let loggedUser = {
                username: result.user.netId,
                nombreCompleto: result.user.username, 
                emailAddress: result.user.emailAddress,
                netId: result.user.netId,
                idinv: result.user.idinv,
                idunidad: result.user.idunidad,
                unidad: result.user.unidad,
                nombres: result.user.nombres,
                apellidos: result.user.apellidos,
                tipoidentificacion: result.user.tipoidentificacion,
                numeroidentificacion: result.user.numeroidentificacion,
                codestudiante: result.user.codestudiante,
                idpersona: result.user.idpersona,
                roles: result.user.roles,
                foto: result.user.foto,
                token: result.token,
                autorizado: result.user.autorizado,
                crearproyecto: result.user.crearproyecto,
                orcid: result.user.orcid,
                hindex: result.user.hindex,
                scholarid: result.user.scholarid,
                scopusid: result.user.scopusid,                
            };

            let realFetch = window.fetch;
            window.fetch = function (url, opts = null) {
                let headers = opts.headers;
                /*console.log("fetch opts = " + JSON.stringify(opts.headers));*/
                if (loggedUser.token) {
                    headers = Object.assign({}, headers, { 'Authorization': `Bearer ${loggedUser.token}` });
                    //console.log("fileupload = " + url.indexOf('FileUpload'));
                    //console.log("content-type = " + headers['Content-Type']);
                    if (url.indexOf('FileUpload') < 0 && headers['Content-Type'] === undefined) {
                        /*console.log("add content-type");*/
                        headers = Object.assign({}, headers, { 'Content-Type': 'application/json' });
                        //opts = Object.assign({}, opts, { 'headers': { 'Content-Type': 'application/json'} });
                    }
                    //opts = Object.assign({}, opts, { 'headers': { 'Authorization': `Bearer ${loggedUser.token}` } });
                    opts.headers = headers;
                    return realFetch(url, opts);
                } else {
                    return realFetch(url, opts);
                }
            };
            //console.log(loggedUser)
            currentUserSubject.next(loggedUser);
        });
}

function logout() {
  // remove user and go to logout CAS
  currentUserSubject.next(null);
  window.location.href = "/Account/Logout";
}